<template>
  <div class="root">
    <!-- {{ banner.name }} -->
    <div class="left">
      <div class="config-title">
        <span>
          banner位置
        </span>
        <!-- <span>
          类型
        </span> -->
      </div>
      <div class="line"></div>
      <div class="emun">
        <div v-if="!!banner.bannInfo || banner.bannInfo.length != 0">
          <div v-for="(item,index) in banner.bannInfo" :key="index" @click="clickBtn(item,index)" :class="{'emun-active':activeIndex == index}">
            <span>{{ item.location }}</span>
            <!-- <span>{{ item.type }}</span> -->
          </div>
        </div>
        <div v-if="!!!banner.bannInfo || banner.bannInfo.length == 0">
          暂无数据
        </div>
      </div>
    </div>
    <div class="right">
      <div class="warp-btn">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="operateShow(3)">新增</el-button>
      </div>

      <TableBlock :ispage="false" ref="tableData" :columns="columns" :action="action" :param="param" :navHeight="290">
         
      </TableBlock>
    </div>
    <BannerAddEdit :banner="banner" ref="bannerAddEdit"></BannerAddEdit>
  </div>
</template>

<script>
import {operate} from '../../../utils/config'

import {columns} from './columns'

import BannerAddEdit from './banner-add-edit'

export default {
  components:{
    BannerAddEdit
  },
  props:{
    banner:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      // banner: {
      //   bannInfo:[]
      // },
      testBannerEmun:[
        
      ],
      activeIndex:0,
      columns:[],
      action:operate.GETBANNERDETAILSLIST,
      param:{
        blId:''
      },
      isBanner:false
    };
  },
  mounted(){
    this.columns = columns(this);
  },
  methods: {
    open(param){
      // this.banner = param.banner;
      this.activeIndex = 0;
      // this.isBanner = true;
      this.banner.getBannerDetailsList(this);
    },
    clickBtn(item,index){
      this.activeIndex = index;
      console.log('更新',item);
      this.banner.cutSidebar(item,this);
    },
    getList(){
      this.banner.getBannerDetailsList(this);
    },
    operateShow(index,item){
      console.log('操作',index,item);
      switch (index){
        case 1:
          this.$refs.bannerAddEdit.open({banner:this.banner},'edit',item);
        break;
        case 2:

            this.$confirm('是否删除这个banner?', '删除', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if(this.banner.delBanner(item,this))return;
              // this.banner.getBannerDetailsList(this);
              this.$parent.getList();
            })

        break;
        case 3:
          console.log('打开')
          this.$refs.bannerAddEdit.open({banner:this.banner},'add',item); 
        break;
      } 
    }
  }
}
</script>

<style lang="scss" scoped>  
  .root{
    height: 100%;
    width: 100%;
  }
  .left{
    outline:1px solid rgba(150, 148, 148, 0.445);
    border-radius: 10px;
    float: left;
    box-sizing: border-box;
    width: 18%;
    height: 100%;
    padding: 10px;
  }
  .right{
    outline:1px solid rgba(150, 148, 148, 0.445);
    border-radius: 10px;
    float: right;
    width: 80%;
    height: 98%;
    padding-left: 10px;
    padding-top: 10px;
    // background-color: aqua;
  }
  .config-title{
    white-space: nowrap;
    display: inline-block;
    box-sizing: border-box;
    font-size: 1rem;
    font-weight: bold;
    width: 100%;
    padding-left: 15px;
    padding-right: 15px; 
    padding-bottom: 10px;
    span:nth-child(2){
      float: right;
    }
  }

  .line{
    width: 100%;
    border:0.5px solid rgb(227, 227, 227);
  }

  .emun{
    // padding-left: 10px;
    // padding-right: 10px; 
    height: 93%;
    overflow: auto;
    overflow-x: hidden;
    padding-top: 10px;
    font-size: 13px;
    div{
      // margin-bottom: 5px;
      white-space: nowrap;
      box-sizing: border-box;
      padding-top: 5px;
      padding-bottom:5px;
      padding-left: 15px;
      padding-right: 15px;
      span:nth-child(2){
        float: left;
      }
      span:nth-child(2){
        float: right;
      }
      &:hover{
        background-color: #cccccc32;
      }
    }
  }

  .emun-active{
    background: linear-gradient(to left, #4AA7FF, #246EFF) aqua;
    color: white;
    border-radius: 2px;
  }

  ::v-deep .container{
    padding: 0px;
  }

  ::v-deep .warp-table{
    margin-top: 10px;
    width: 99.3%;
  }

  ::v-deep .container{
    width: 100% !important;
    height: 95% !important;
  }
</style>